// apps/web/src/lib/painel/home/motivo-sem-medicao.ts — Fase 17.8, correção pós-UAT (D3).
// A API manda o `motivo` (slug) quando uma métrica está em SEM_MEDICAO; aqui ele vira uma linha curta em pt-BR, em tom calmo, para o
// herói e os números de apoio dizerem POR QUE não há número em vez de só "—" e "Sem medição". Os slugs são os que os montadores de
// apps/api/src/modules/painel/home emitem; um slug novo ou desconhecido cai no texto genérico (nunca mostra o slug cru).

/** Texto genérico para um motivo que o painel ainda não conhece. */
export const TEXTO_MOTIVO_GENERICO = 'Ainda não há dados suficientes para medir.';

const MOTIVOS: Readonly<Record<string, string>> = {
  // Peças apontadas nas cabines (retrabalho de PCP e Qualidade).
  'sem-pecas-apontadas': 'Nenhuma peça apontada nas cabines no período.',
  'sem-peca-apontada': 'Nenhuma peça apontada nas cabines no período.',
  // Almoxarifado.
  'sem-po-cadastrado': 'Nenhum material de pó cadastrado.',
  // Compras.
  'sem-consumo-medido': 'Nenhum consumo medido no período.',
  'nenhum-minimo-definido': 'Nenhum material tem estoque mínimo definido.',
  // Devolvidas no prazo (PCP e Diretoria).
  'sem-previsao-de-entrega': 'Nenhum item de PV com previsão de entrega.',
  'sem-devolucao-no-periodo': 'Nenhuma devolução nos últimos 30 dias.',
  // Área pintada (herói de PCP e kv da Diretoria): itens sem área unitária cadastrada.
  'sem-area-cadastrada': 'Nenhuma peça apontada com área cadastrada.',
  // Faturamento: pronto para faturar em R$.
  'sem-preco-nos-itens': 'Nenhum item de PV com preço informado.',
  // Esteira do PCP.
  'sem-servicos-no-kanban': 'Nenhuma etapa do Kanban cadastrada.',
  // "Precisa de você": a sessão não enxerga nenhuma categoria.
  'sem-permissao-nas-categorias': 'Seu perfil não acessa estas categorias.',
};

/** Motivo genérico dos números de apoio (sem base e sem nada mais específico a dizer): o chamador mantém o "Sem medição". */
const MOTIVO_SEM_DETALHE = 'sem-medicao';

/**
 * Linha amigável do motivo de um SEM_MEDICAO. Sem motivo (ou o genérico `sem-medicao`) devolve `undefined`: o chamador mantém o
 * "Sem medição" de sempre. Motivo desconhecido devolve o texto genérico.
 */
export function textoDoMotivoSemMedicao(motivo: string | undefined): string | undefined {
  if (motivo === undefined || motivo === '' || motivo === MOTIVO_SEM_DETALHE) return undefined;
  return MOTIVOS[motivo] ?? TEXTO_MOTIVO_GENERICO;
}
